import { createContext, useContext, useMemo, useState } from 'react';
import usePostalCodesActions from '../hooks/APIHooks/users/usePostalCodesActions';
import { PostalCode } from '../types/postalCodes';

// datatype of the context declared here
interface IPostalCodeContext {
  targetedPostalCode: PostalCode | null;
  postalCodeList: Array<PostalCode>;
  showDeleteModal: boolean;
  showViewModal: boolean;
  setTargetedPostalCode: React.Dispatch<
    React.SetStateAction<PostalCode | null>
  >;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowViewModal: React.Dispatch<React.SetStateAction<boolean>>;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

// creating the context here
const PostalCodeContext = createContext<IPostalCodeContext | null>(null);

const PostalCodeProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [targetedPostalCode, setTargetedPostalCode] =
    useState<PostalCode | null>(null);

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showViewModal, setShowViewModal] = useState<boolean>(false);

  // integration of custom API hooks here
  const { getPostalCodeListHandler } = usePostalCodesActions('postalCodeList');

  console.log('POSTAL CODE LIST: ', getPostalCodeListHandler.data?.data);

  // setting postal codes into local state here
  const postalCodeList = useMemo(() => {
    if (!getPostalCodeListHandler.data?.is_success) return [];

    return getPostalCodeListHandler.data.data;
  }, [getPostalCodeListHandler.data]);

  // rendering the context provider here
  return (
    <PostalCodeContext.Provider
      value={{
        targetedPostalCode,
        postalCodeList,
        showDeleteModal,
        showViewModal,
        setTargetedPostalCode,
        setShowDeleteModal,
        setShowViewModal,
        isError: getPostalCodeListHandler.isError,
        isLoading: getPostalCodeListHandler.isLoading,
        isSuccess: getPostalCodeListHandler.isSuccess,
      }}
    >
      {children}
    </PostalCodeContext.Provider>
  );
};

export default PostalCodeProvider;

// custom hook to access the context declared here
export const usePostalCodeContext = () => {
  const context = useContext(PostalCodeContext);

  if (!context) {
    throw new Error('usePostalCodeContext must be within PostalCodeProvider!');
  }

  return context;
};
